document.addEventListener('DOMContentLoaded', function() {
  const pickupOption = document.querySelector('.pickup-option.available');
  const deliveryOption = document.querySelector('.delivery-option.available');
  const delayedPickupOption = document.querySelector('.delayed-pickup-option.available');
  
  // Function to handle option selection
  function handleOptionSelect(option, fulfillmentType) {
    // Remove selected class from all options
    document.querySelectorAll('.option.available').forEach(el => el.classList.remove('selected'));
    
    // Add selected class to clicked option
    option.classList.add('selected');
    
    // Add hidden field to the form
    const form = document.querySelector('form[action="/cart/add"]');
    if (form) {
      let input = form.querySelector('input[name="properties[Fulfillment]"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Fulfillment]';
        form.appendChild(input);
      }
      input.value = fulfillmentType;
      
      // Also add the selection as a data attribute to the form
      form.setAttribute('data-fulfillment', fulfillmentType);
    }
  }
  
  // Add click listeners to each option
  if (pickupOption) {
    pickupOption.addEventListener('click', function() {
      handleOptionSelect(this, 'Store Pickup Today');
    });
  }
  
  if (deliveryOption) {
    deliveryOption.addEventListener('click', function() {
      handleOptionSelect(this, 'Delivery');
    });
  }
  
  if (delayedPickupOption) {
    delayedPickupOption.addEventListener('click', function() {
      handleOptionSelect(this, 'Ship to Store');
    });
  }
  
  // Auto-select first available option if none is selected
  const selectedOption = document.querySelector('.option.selected');
  if (!selectedOption) {
    const firstAvailableOption = document.querySelector('.option.available');
    if (firstAvailableOption) {
      if (firstAvailableOption.classList.contains('pickup-option')) {
        handleOptionSelect(firstAvailableOption, 'Store Pickup Today');
      } else if (firstAvailableOption.classList.contains('delivery-option')) {
        handleOptionSelect(firstAvailableOption, 'Delivery');
      } else if (firstAvailableOption.classList.contains('delayed-pickup-option')) {
        handleOptionSelect(firstAvailableOption, 'Ship to Store');
      }
    }
  }
  
  // For mobile - improve touch targets
  const infoIcons = document.querySelectorAll('.info-icon');
  infoIcons.forEach(icon => {
    // Make sure tooltips work well on touch devices
    icon.addEventListener('touchstart', function(e) {
      e.stopPropagation();
      
      // Remove active class from all other icons
      infoIcons.forEach(otherIcon => {
        if (otherIcon !== icon) {
          otherIcon.classList.remove('active');
        }
      });
      
      // Toggle active class on this icon
      this.classList.toggle('active');
    });
  });
  
  // Close tooltips when tapping elsewhere
  document.addEventListener('touchstart', function() {
    infoIcons.forEach(icon => {
      icon.classList.remove('active');
    });
  }, {passive: true});
});